<!--华普定制头部-->
<template>
  <div class="hpTitleBody" v-bind:style="backImg">
    <div class="serviceTerm">

    </div>
    <div class="hpUserTitle flexCenterColumn" @click="tempClick">
      <span>{{nowUnit.name}}</span>
      <img :src="imgName('huapu/userTitle.png')" />
    </div>
    <div style="padding-right: .2rem;">
    </div>
  </div>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import request from "@/api/http.js";

  export default {
    data () {
      return {
        loadDeviceList: '',
        deviceNoToArchivesInfo: '',
      }
    },

    methods: {

      tempClick (v) {
        this.$api.eventApi.countEventListByUser('1051231df55d44b38195318a54ce12ec','B5A693FA77804BC8BE009D57D0E7A788','',-1,'','','','','',res => {
          console.log(res,11);
        })
        //获取变压器负荷设备列表

        // 
        // var params={unitId: this.$store.unitStore.getters.getNowUnit.id} 
        // request({url: "/power/countDevicePower.do",method: "get"}).then(res => { //负荷设备数
        //   console.log(res);
        // })
      }
    },
    computed: {
      loadCapacity () {
        //总负荷容量,负荷设备是负荷配置中配置的当前单位的负荷设备，然后通过他们绑定的台账来查询额定容量属性
        var count=0
        for(var i=0,len=this.loadDeviceList.length;i<len;i++) {
          var item=this.loadDeviceList[i]
          var info=this.deviceNoToArchivesInfo[item.deviceno]
          if(!isempty(info)&&!isempty(info.next)) {
            var target=info.next.find(it => it.propertyCode=="Capacity")
            let target2=info.next.find(it => it.propertyCode=="edrl")
            if(!isempty(target)&&!isempty(target.value)) {
              try {
                count+=parseFloat(target.value)
              } catch(e) {}
            }
            if(!isempty(target2)&&!isempty(target2.value)) {
              try {
                count+=parseFloat(target2.value)
              } catch(e) {}
            }
          }
        }
        // console.log("parseInt(count)",parseInt(count));
        return parseInt(count)
      },
      imgName () {
        return resourcesStore.getters.getResourcesByName
      },
      backImg () {
        return {
          //'background-image': 'url(' + this.imgName('huapu/background.png') + ')'
        }
      },
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
      timeJudge () {
        var expirationTime=new Date(this.nowUnit.expirationTime).getTime()
        var currentTime=new Date()
        //计算后的时间
        var calculatingTime=(expirationTime-currentTime)/1000/60/60/24
        if(calculatingTime>15) {
          return {
            'color': '#4eb11e'
          }
        } else if(calculatingTime<=0) {
          return {
            'color': 'red'
          }
        } else if(calculatingTime<=15) {
          return {
            'color': '#d4d022'
          }
        }
      }
    },

  }
</script>

<style scoped>
  .hpTitleBody {
    margin: 5px 0;
    background-size: 10%;
    width: 100%;
    height: calc(8% - 10px);
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .hpTitleBody img {
    width: .3rem;
  }

  .hpTitleBody div {
    display: flex;
    align-items: center;
  }

  .hpTitleBody span {
    color: white;
  }

  .hpUserTitle {
    width: 40%;
    height: 100%;
  }

  .hpUserTitle span {
    padding-top: 2px;
    font-size: .18rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    text-align: center;
    overflow: hidden;
  }

  .hpUserTitle img {
    width: 100%;
    padding-top: 2px;
  }

  .serviceTerm {
    padding-left: .2rem;
  }

  .serviceTerm img,
  span {
    padding-left: .1rem;
  }
</style>